import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { StationModel } from '@/libs/Api';
import { StationsDataService } from '@/libs/stations/stations-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const stationsStore = registerCrudStore<StationModel, StationModel>(BusinessModule.Station, new StationsDataService());
